import styled from 'styled-components';

export const ChipsWrapper = styled.div<{ $locked?: boolean; $blank?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex: 0 100%;
  margin-left: ${({ $locked, $blank }) => ($locked || $blank ? '0' : '10px')};
  position: relative;
  input {
    outline: none;
    margin-left: 5px;
    flex-grow: 1;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      color: ${({ theme }) => theme.baseBlue.a6};
      opacity: 1;
    }
  }
`;

export const ChipsInputContainer = styled.div<{ $locked?: boolean; $isFocused?: boolean; $error?: boolean }>`
  display: flex;
  align-items: center;
  padding: ${({ $locked }) => ($locked ? '0' : '5px 10px')};
  min-height: ${({ $locked }) => ($locked ? '0' : '60px')};
  > div {
    &.iconSearch {
      color: ${({ theme, $isFocused, $error }) =>
        $error ? theme.red.a10 : $isFocused ? theme.baseBlue.a10 : theme.baseBlue.a3};
    }
  }
`;
